import { topics } from '@/mocks/baoliao';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200 hover:bg-secondary-200',
};

const dotMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function TopicTags() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网最热爆料话题，点击查看你感兴趣的瓜料合集
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#ranking"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${colorMap[topic.color]}`}
            >
              {topic.trending && (
                <span className={`w-2 h-2 rounded-full ${dotMap[topic.color]}`}></span>
              )}
              <span>{topic.name}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
              {topic.trending && (
                <span className="text-xs px-1.5 py-0.5 rounded bg-primary-500/10 text-primary-600 font-bold">
                  HOT
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}